var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editSoaIndex === _vm.index && !_vm.soa.isAutoSoa)?[_c('DataPicker',{attrs:{"font-size":"14","default-date":_vm.dateEdit,"table":true},on:{"setDate":_vm.setSoaDate}})]:[_vm._v("\n    "+_vm._s(_vm.formatDate(_vm.soa.date))+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1486bc01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/DateColumn.vue
// module id = null
// module chunks = 